import { defineStore } from "pinia";
import { computed, ref } from "vue";

export const useLoadingStore = defineStore("loadingStore", () => {
  const courses = ref([
    {
      title: "Write Up Processes",
      thumbnail:
        "https://webinarinc-v2-development.s3.us-west-2.amazonaws.com/units/947/4206b5d6baf822f2aa8fcbb8aee554ae.png",
    },
    {
      title: "Mileage Awareness",
      thumbnail:
        "https://webinarinc-v2-development.s3.us-west-2.amazonaws.com/units/986/d016a50770778f33a9be2685e3c7437c.png",
    },
    {
      title: "Pricing Management",
      thumbnail:
        "https://webinarinc-v2-development.s3.us-west-2.amazonaws.com/units/394/2aaac816d36a8f744eaa8d8361c13085.png",
    },
    {
      title: "Service Lane Selling",
      thumbnail:
        "https://webinarinc-v2-development.s3.us-west-2.amazonaws.com/units/950/8c6b377de579d22ee6b8a0612b013610.png",
    },
    {
      title: "Handling Diagnosis",
      thumbnail:
        "https://webinarinc-v2-development.s3.us-west-2.amazonaws.com/units/961/b12bdb3bb8fcdb33a306e8e2212c97d7.png",
    },
    {
      title: "Patching a Tire",
      thumbnail:
        "https://i.vimeocdn.com/video/1890025427-c535e2229b33ba2489462e78f8594e61b8c5ee4977c11759f8d68f1667ea5efc-d_295x166",
    },
    {
      title: "Tech Connect -Benefits of MPI",
      thumbnail:
        "https://i.vimeocdn.com/video/1910222945-86f68433befff9387923128f8dea7b6f6a85368978fb3da18093102f8dd2a7f8-d_295x166",
    },
    {
      title: "The Appraisal Blueprint - Webinar",
      thumbnail:
        "https://i.vimeocdn.com/video/1861506492-57e72adb0813e1992db13fcd986fdfa7f562f966a1444df1d3403f9c305c1a76-d_640",
    },
    {
      title: "The Three C's",
      thumbnail:
        "https://i.vimeocdn.com/video/2022159059-7bea55e3793e04f3ed90bcaf76f07e4088f7068f07866498dd06b90015cabd09-d_295x166?region=us",
    },
    {
      title: "Navigating X-time",
      thumbnail:
        "https://i.vimeocdn.com/video/2015803268-3df2a27e450e2fe42278e46fcf3280ab046da0bcff835ca3628576d8f59c3359-d_295x166?region=us",
    },
  ]);

  const categories = ref([
    {
      title: "Advisor",
      thumbnail:
        "https://lms-v3.s3.us-east-1.amazonaws.com/hudson-categories/Category+3+-+Advisor.avif",
    },
    {
      title: "All Employees",
      thumbnail:
        "https://lms-v3.s3.us-east-1.amazonaws.com/hudson-categories/Category+4+-+All+Employees.avif",
    },
    {
      title: "Between 2 Cars",
      thumbnail:
        "https://lms-v3.s3.us-east-1.amazonaws.com/hudson-categories/Category+5+-+Between+2+Cars.avif",
    },
    {
      title: "CDK",
      thumbnail:
        "https://lms-v3.s3.us-east-1.amazonaws.com/hudson-categories/Category+6+-+CDK.avif",
    },
    {
      title: "F&I",
      thumbnail:
        "https://lms-v3.s3.us-east-1.amazonaws.com/hudson-categories/Category+7+-+F%26I.avif",
    },
    {
      title: "Hiring Managers",
      thumbnail:
        "https://lms-v3.s3.us-east-1.amazonaws.com/hudson-categories/Category+9+-+Hiring+Managers.avif",
    },
    {
      title: "Leadership",
      thumbnail:
        "https://lms-v3.s3.us-east-1.amazonaws.com/hudson-categories/Category+9+-+Hiring+Managers.avif",
    },
    {
      title: "Parts",
      thumbnail:
        "https://lms-v3.s3.us-east-1.amazonaws.com/hudson-categories/Category+13+-+Parts.jpg",
    },
  ]);

  const playlist = ref([
    {
      title: "Introduction to Sales",
      thumbnail:
        "https://i.vimeocdn.com/video/1936446809-18af05584621747c7aad4fec48453fb6b0487e6acf412b223f64dc65e7bddad7-d_295x166",
    },
    {
      title: "Stonecrest Honda New Sales Consultant Training",
      thumbnail:
        "https://i.vimeocdn.com/video/1774291205-4da0932e8a67e270a7faf4197bd2c5ec0642943e717573479c60807b7ee9ace1-d",
    },
    {
      title: "Parts & Accounting",
      thumbnail:
        "https://i.vimeocdn.com/video/1813643620-776de8e941b49dcaab5841c79f4674d1d895c0782fc408c6a0540c061c130212-d_295x166",
    },
    {
      title: "CRM Basics - eLeads",
      thumbnail:
        "https://i.vimeocdn.com/video/1954290558-39d6790f7e0590382cf5d6e759fa12340e24f00f49a35d254d7fded453ec84cf-d_295x166",
    },
  ]);

  const shuffledCourses = computed(() => {
    const arr = [...courses.value];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  });

  const shuffledCategories = computed(() => {
    const arr = [...categories.value];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  });

  const shuffledPlaylist = computed(() => {
    const arr = [...playlist.value];
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  });

  return {
    courses,
    categories,
    playlist,
    shuffledPlaylist,
    shuffledCourses,
    shuffledCategories,
  };
});
